// extracted by mini-css-extract-plugin
export const container = "menus-module--container--1QBnM";
export const inside = "menus-module--inside--lRAuD";